import { render, staticRenderFns } from "./PlayerBalance.vue?vue&type=template&id=5e9a12dc&scoped=true"
import script from "./PlayerBalance.vue?vue&type=script&lang=js"
export * from "./PlayerBalance.vue?vue&type=script&lang=js"
import style0 from "./PlayerBalance.vue?vue&type=style&index=0&id=5e9a12dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9a12dc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default})
